import React from 'react'
import { Route, Switch } from 'react-router'
import List from './List'
import Members from './Members'
import Form from './Form'
import InsideProject from './InsideProject'
import Directory from './Directory'
import Types from './Types'
import Questions from './Questions'
import Stackholders from './Stackholders'
import Factors from './Factors'
import Activities from './Activities'
import Resources from './Resources'
import IndicatorGenerator from './IndicatorGenerator'
import IndicatorGeneratorViewer from './IndicatorGeneratorViewer'

const Organizations = (props) => {
    return (
        <React.Fragment>
            <Switch>
                <Route path={`/projects/indicator-generator/:organization/:code`} exact component={IndicatorGenerator} />
                <Route path={`/projects/indicator-generator/:organization/:code/:indicator`} exact component={IndicatorGeneratorViewer} />
                <Route path={`/projects/:organization/:code/`} component={() => {
                    return (
                        <React.Fragment>
                            <Route path={`/projects/:organization/:code/questions/:subsection`} exact component={Questions} />
                            <Route path={`/projects/:organization/:code/types`} exact component={Types} />
                            <Route path={`/projects/:organization/:code/members`} exact component={Members} />
                            <Route path={`/projects/:organization/:code/stackholders`} exact component={Stackholders} />
                            <Route path={`/projects/:organization/:code/factors`} exact component={Factors} />
                            <Route path={`/projects/:organization/:code/activities#activities`} exact component={Activities} />
                            <Route path={`/projects/:organization/:code/resources#resources-and-limitations`} exact component={Resources} />
                            <Switch>
                                <Route path={`/projects/:organization/:code/directory`} exact component={Directory} />
                                <Route path={`/projects/:organization/:code/`} component={InsideProject} />
                            </Switch>
                        </React.Fragment>
                    )
                }} />
                <Route path={`/projects`} component={() => {
                    return (
                        <React.Fragment>
                            <Route path={`/projects/new`} exact component={Form} />
                            <Route path={`/projects`} component={List} />
                        </React.Fragment>
                    )
                }} />
            </Switch>
        </React.Fragment>
    )
}


export default Organizations;


// WEBPACK FOOTER //
// ./src/routers/Projects/index.js